export function configureRouter (router) {
}




// WEBPACK FOOTER //
// ./src/router/routerConfig.js